export const getSizeToPrintOnScreen = (
  localize: (param: string) => string,
  config: { numeric?: number; alpha: string },
  enabledFeatures: { [key: string]: boolean }
) => {
  const alphaNumeric = enabledFeatures['cat-model-toggle-alphanumeric'];
  const alpha = enabledFeatures['cat-model-toggle-alpha'];

  if (alphaNumeric) {
    return `${config.numeric} (${localize(config.alpha)})`;
  } 
  
  if (alpha) {
    return localize(config.alpha);
  }

  return config.numeric;
};
